jQuery(document).ready(function() {

  jQuery('.search_on_page input[type=text]').on('keyup', function() {
    var value = jQuery(this).val(),
        character_limit_low = 3,
        elements_to_search = jQuery('.fusion-title, .accordian .fusion-panel, .faq_grid [data-active]'); // .fusion-column-wrapper h1,

    jQuery('[quick-search-match]').attr('quick-search-match',0);
    jQuery('[quick-search-match-within]').attr('quick-search-match-within',0);
    jQuery('[quick-search-live]').attr('quick-search-live',0);
    jQuery('.search_on_page .response').text();
    elements_to_search.find('.highlight').removeClass('highlight');
    jQuery('.search_on_page .response').text('');

    if( value.length >= character_limit_low ) {
      var count_found = 0,
          count_lost = 0,
          response = '';
      elements_to_search.each( function() {
        var parent = jQuery(this).closest('.fusion-faq-shortcode'),
            title = parent.prevAll('.fusion-title').first();
        jQuery('[quick-search-live]').attr('quick-search-live', 1);
        title.attr('quick-search-live', 1);
        var this_text = jQuery(this).text().toLowerCase();
        if( this_text.indexOf(value.toLowerCase()) >= 0 ) {
          jQuery(this).attr('quick-search-match', 1);
          jQuery('[quick-search-live]').attr('quick-search-match-within', 1);
          title.attr('quick-search-match-within', 1);
          count_found++;

          // highlight
          // var text_containers = jQuery('.fusion-title > *, .fusion-toggle-heading, .panel-body');
          // text_containers.each( function() {
          //   var content = jQuery(this).html();
          //   content = content.replace(value, '<span class="highlight">' + value + '</span>');
          //   jQuery(this).html(content);
          // });
        } else {
          jQuery(this).attr('quick-search-match', 0);
          count_lost++;
        }

        console.log(count_found);

        if( count_found > 0 ) {
          response = count_found + ' matches found';
          // response += '. Dropped ' + count_lost;
        } else {
          response = '0 matches found, try a broader search';
        }
        jQuery('.search_on_page .response').text(response);
      });
    } else {
      jQuery('[quick-search-live]').attr('quick-search-live',0);
      jQuery('span.highlight').removeClass('.highlight');
    }

    console.log({value});
  });

});
